import { gql } from '@apollo/client';

export const OrganizationFragment = gql`
  fragment OrganizationFragment on Organization {
    id
    name
  }
`;
